import React from 'react';
import './WindowPage.css';

import { PageTitle, Heading, Style } from '../../../components';
import { windowFaqs, windowIntro, windows } from '../../../constants';
import { Banner, WhyChooseUs, FAQs } from '../../../sections';

import { MdWindow } from 'react-icons/md';



const WindowPage = () => { 

  return ( 
    <>
      {/* Page Title Section */}
      <PageTitle title={'Windows'} page={'Windows'} />

      <div className='window-page'>

        {/* Window Introduction */}
        <section className="about">

          {/* About Image */}
          <div className="image">
            <div className="sub-image one">
              <img src={windowIntro.image.src1} alt={windowIntro.image.alt1} />
              <img src={windowIntro.image.src2} alt={windowIntro.image.alt2} />
            </div>
            <div className="sub-image one last">
              <img src={windowIntro.image.src3} alt={windowIntro.image.alt3} />
              <img src={windowIntro.image.src4} alt={windowIntro.image.alt4} />
            </div>
          </div>

          {/* Introduction Content */}
          <div className="content">

            {/* Section Heading */}
            <Heading title={windowIntro.heading} subTitle={windowIntro.sub} sideHeading />

            {/* Description */}
            {windowIntro.description.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Key Features */}
            <div className="about-features">
              {windowIntro.points.map((point, index) => (
                <ul key={index}>
                  <li>
                    <div className='icon'><MdWindow /></div>
                    <span>{point}</span>
                  </li>
                </ul>
              ))}
            </div>

          </div>
        </section>

        {/* Banner Section */}
        <Banner />

        {/* Window Styles */}
        <section className='styles'>

          {/* Section heading */}
          <Heading title={'Window Styles'} subTitle={'Explore Our Window Styles'} />

          <div className='box-container'>

            {/* Map over the windows array to render each window */}
            {windows.map((window) => { 
              return (
                <Style key={window.id} style={window} basePath="Windows" />
              );
            })}

          </div>

        </section>

        {/* Why Choose Us */}
        <WhyChooseUs />

        {/* Windows FAQs */}
        <FAQs faqsContent={windowFaqs} />
 
      </div>

    </>
  )
}

export default WindowPage;